import { render, staticRenderFns } from "./previewCCXS.vue?vue&type=template&id=500c78fd&scoped=true&lang=html&"
import script from "./previewCCXS.vue?vue&type=script&lang=js&"
export * from "./previewCCXS.vue?vue&type=script&lang=js&"
import style0 from "./previewCCXS.vue?vue&type=style&index=0&id=500c78fd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500c78fd",
  null
  
)

export default component.exports